/**
 * Upgrade http:// URLs to https:// when the host page is served over HTTPS.
 * Prevents mixed-content blocking while keeping plain http:// on local HTTP dev.
 */
export function secureImageUrl(url: string): string {
  if (typeof window === 'undefined' || !url) return url;
  if (window.location.protocol === 'https:' && url.startsWith('http://')) {
    return 'https://' + url.slice(7);
  }
  return url;
}
